/* eslint-disable no-restricted-syntax */
import { all, call, put, takeLatest, takeLeading, } from 'redux-saga/effects';

import * as apicore from "services/core";
import * as type from './constant';
import * as action from './action';

function* getListItems({ params, selfRole }) {
  try {

    const data = [];
    let p = 0;
    let tp = 0;
    do {
      const { results, page, totalPages } = yield call(apicore.getExecutorRequest, { ...params, page: p + 1, limit: 50 }, selfRole);
      data.push(...results)
      p = page;
      tp = totalPages;
    } while (p < tp);
    
    yield put(action.getExecutorSuccess(data));

  } catch (error) {
    yield put(action.getExecutorError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* addItem({ payload, selfRole }) {
  try {

    const response = yield call(apicore.addExecutorRequest, payload, selfRole);
    yield put(action.addExecutorSuccess(response));

  } catch (error) {
    yield put(action.manipulationExecutorError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateItem({ id, payload, selfRole }) {
  try {

    const response = yield call(apicore.updateExecutorRequest, id, payload, selfRole);
    yield put(action.updateExecutorSuccess(response));

  } catch (error) {
    yield put(action.manipulationExecutorError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* deleteItem({ ids, selfRole }) {
  try {

    for (const id of ids) {
      yield call(apicore.deleteExecutorRequest, id, selfRole);
    }
    
    yield put(action.deleteExecutorSuccess(true));

  } catch (error) {
    yield put(action.manipulationExecutorError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* getSelfItem({ selfRole }) {
  try {

    const response = yield call(apicore.getExecutorSelfRequest, selfRole);
    yield put(action.getExecutorSelfSuccess(response));

  } catch (error) {
    yield put(action.getExecutorError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

export function* watchGetList() {
  yield takeLatest(type.GET, getListItems);
}
export function* watchAddList() {
  yield takeLeading(type.ADD, addItem);
}
export function* watchUpdateItem() {
  yield takeLeading(type.UPDATE, updateItem);
}
export function* watchDeleteItem() {
  yield takeLeading(type.DELETE, deleteItem);
}
export function* watchGetSelfItem() {
  yield takeLatest(type.GET_SELF, getSelfItem);
}

export default function* rootSaga() {
  yield all([
    watchGetList(),
    watchUpdateItem(),
    watchAddList(),
    watchDeleteItem(),
    watchGetSelfItem(),
  ]);
}
